// ISO 3166 country code -> ISO 4217 currency, for the "estimated price in your
// currency" line. Countries not listed fall back to USD.
const EURO = "AD AT BE CY DE EE ES FI FR GF GP GR HR IE IT LT LU LV MC ME MF MQ MT NL PM PT RE SI SK SM VA XK YT AX BL";

const CURRENCIES =
  "AE:AED AF:AFN AL:ALL AM:AMD AO:AOA AR:ARS AU:AUD AW:AWG AZ:AZN BA:BAM BB:BBD BD:BDT BF:XOF BG:BGN BH:BHD " +
  "BI:BIF BJ:XOF BM:BMD BN:BND BO:BOB BR:BRL BS:BSD BT:BTN BW:BWP BY:BYN BZ:BZD CA:CAD CD:CDF CF:XAF CG:XAF " +
  "CH:CHF CI:XOF CK:NZD CL:CLP CM:XAF CN:CNY CO:COP CR:CRC CU:CUP CV:CVE CW:ANG CZ:CZK DJ:DJF DK:DKK DM:XCD " +
  "DO:DOP DZ:DZD EG:EGP EH:MAD ER:ERN ET:ETB FJ:FJD FK:FKP FO:DKK GA:XAF GB:GBP GD:XCD GE:GEL GG:GBP GH:GHS " +
  "GI:GIP GL:DKK GM:GMD GN:GNF GQ:XAF GT:GTQ GW:XOF GY:GYD HK:HKD HN:HNL HT:HTG HU:HUF ID:IDR IL:ILS IM:GBP " +
  "IN:INR IQ:IQD IR:IRR IS:ISK JE:GBP JM:JMD JO:JOD JP:JPY KE:KES KG:KGS KH:KHR KI:AUD KM:KMF KN:XCD KR:KRW " +
  "KW:KWD KY:KYD KZ:KZT LA:LAK LB:LBP LC:XCD LI:CHF LK:LKR LR:LRD LS:LSL LY:LYD MA:MAD MD:MDL MG:MGA MK:MKD " +
  "ML:XOF MM:MMK MN:MNT MO:MOP MR:MRU MU:MUR MV:MVR MW:MWK MX:MXN MY:MYR MZ:MZN NA:NAD NC:XPF NE:XOF NF:AUD " +
  "NG:NGN NI:NIO NO:NOK NP:NPR NR:AUD NU:NZD NZ:NZD OM:OMR PA:PAB PE:PEN PF:XPF PG:PGK PH:PHP PK:PKR PL:PLN " +
  "PN:NZD PY:PYG QA:QAR RO:RON RS:RSD RU:RUB RW:RWF SA:SAR SB:SBD SC:SCR SD:SDG SE:SEK SG:SGD SH:SHP SJ:NOK " +
  "SL:SLE SN:XOF SO:SOS SR:SRD SS:SSP ST:STN SY:SYP SZ:SZL TD:XAF TG:XOF TH:THB TJ:TJS TK:NZD TM:TMT TN:TND " +
  "TO:TOP TR:TRY TT:TTD TV:AUD TW:TWD TZ:TZS UA:UAH UG:UGX UY:UYU UZ:UZS VC:XCD VE:VES VN:VND VU:VUV WF:XPF " +
  "WS:WST YE:YER ZA:ZAR ZM:ZMW ZW:ZWL AI:XCD AG:XCD MS:XCD SX:ANG";

const MAP: Record<string, string> = Object.fromEntries([
  ...EURO.split(" ").map((c) => [c, "EUR"]),
  ...CURRENCIES.split(" ").map((pair) => pair.split(":")),
]);

export const currencyFor = (country: string) => MAP[country] ?? "USD";

// The "African Markets" price group. The backend applies the same list when it
// creates the PayPal order; this copy only decides which price to show.
export const AFRICAN_MARKETS = new Set(
  (
    "DZ AO BJ BW BF BI CV CM CF TD KM CG CD CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU " +
    "MA MZ NA NE NG RW ST SN SC SL SO ZA SS SD TZ TG TN UG ZM ZW EH RE YT SH"
  ).split(" ")
);

// Shown first in the country picker, as in the design
export const FEATURED_COUNTRIES = ["NG", "GH", "KE", "US", "CA", "GB"];
